export enum MimeTypes {
	ApplicationJson = 'application/json',
	TextPlain = 'text/plain'
}
